import React, { Fragment, useRef, useEffect, useMemo } from "react";
import { useHits, useQueryRules } from "react-instantsearch";
import Banner from "../Advertisements/Banner";
import Hit from "./Hit/Hit";
import { useMediaQuery } from "react-responsive";
import { useSelector } from "react-redux";
import { useGSAP } from "@gsap/react";
import { hitsAnimation } from "./hits-animation";
import { gsap } from "gsap";
import isEqual from "lodash/isEqual";

const CustomHits = (props) => {
    const { hits, results } = useHits(props);
    const customHits = hits;
    let currentElementIndex = useRef(0);

    const initAllFiltersOverlay = useSelector(
        (state) => state.overlay.initAllFiltersOverlay,
    );

    const { items } = useQueryRules(props);
    const advertisements = useMemo(
        () =>
            items
                .map((element) =>
                    element.bannerData ? element.bannerData : [],
                )
                .flat(),
        [items],
    );

    const previousHitsRef = useRef();

    useEffect(() => {
        if (initAllFiltersOverlay && results.hits.length > 0) {
            if (!isEqual(previousHitsRef.current, results.hits)) {
                window.dataLayer = window.dataLayer || [];
                window.dataLayer.push({ event: "Hits Viewed" });
                // console.log("Hits Viewed");

                // Update the previous hits ref with the current hits
                previousHitsRef.current = results.hits;
            }
        }
        return () => {
            // console.log("No Hits Viewed");
        };
    }, [initAllFiltersOverlay, results.hits]); // Update the dependency array

    const bannerMapping = (hit, hitProperty) =>
        advertisements.length > 0
            ? advertisements.map((banner, bannerIndex) =>
                  hitProperty === banner.matchingProperty &&
                  hit[banner.matchingProperty][bannerIndex] ===
                      banner.propertyValue &&
                  currentElementIndex.current < 1
                      ? (() => {
                            currentElementIndex.current++;
                            switch (banner.type) {
                                case "advertisement":
                                    return (
                                        <Banner
                                            key={bannerIndex}
                                            headline={banner.headline}
                                            subheadline={banner.subheadline}
                                            features={banner.features}
                                            matchingProperty={
                                                banner.matchingProperty
                                            }
                                            buttonText={banner.buttonText}
                                            buttonLink={banner.buttonLink}
                                            image_url={banner.image_url}
                                        />
                                    );
                                default:
                                    return null;
                            }
                        })()
                      : null,
              )
            : null;

    const isNotMobile = useMediaQuery({ query: "(min-width: 768px)" });
    const componentRef = useRef();
    const timeline = useRef(gsap.timeline());
    const timelineDelay = useRef(isNotMobile ? 1 : 0.75);

    useGSAP(
        () => {
            const tl = timeline.current;
            tl.add(hitsAnimation(), timelineDelay.current);
        },
        {
            dependencies: [customHits],
            scope: componentRef.current,
        },
    );

    return (
        <div className="ais-Hits search-hits" ref={componentRef}>
            <ol className="ais-Hits-list">
                {customHits.map((hit, hitIndex) => (
                    <Fragment key={hitIndex + " customHit of" + results.page}>
                        <li className="ais-Hits-item">
                            <Hit hit={hit}/>
                        </li>
                        <li className="ais-Hits-item">
                            {Object.keys(hit).map(
                                (hitProperty) =>
                                    hitProperty !== undefined &&
                                    bannerMapping(hit, hitProperty),
                            )}
                        </li>
                    </Fragment>
                ))}
            </ol>
        </div>
    );
};

export default CustomHits;
